//!!!!! TODO: Do not mutate state directly fix it asap!!!!!!
import React from 'react'
import Invoice from "../../../nav/invoice";
import i18 from "../../../../i18";

class RowProcessed extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            invoice: props.invoice,
            invoiceItem: props.invoiceItem,
            keyIndex: props.keyIndex,
            invoiceIndex: props.invoiceIndex,
            itemIndex: props.itemIndex,
            isFirst: props.itemIndex === 0,
            showInvoice: false,
            company: props.company,
        };
    }

    /**
     * @deprecated To be deprecated in React v17.
     * todo: Use new lifecycle static getDerivedStateFromProps instead.
     */
    componentWillReceiveProps = (nextProps) => {
        this.setState({
            invoice: nextProps.invoice,
            invoiceItem: nextProps.invoiceItem,
        });
    };

    onShowInvoice = () => {
        this.setState({
            showInvoice: !this.state.showInvoice,
        })
    }

    onSetBookKeepingNumber = (event) => {
        this.props.onSetBookKeepingNumber(this.state.invoiceIndex, this.state.itemIndex, event.target.value);
    };

    deleteInvoiceItem = () => {
        this.props.deleteInvoiceItem(this.state.keyIndex);
        this.props._addNotification('A tétel törölve lett a kimenetből', 'warning', 30);
    }

    deleteInvoice = () => {
        this.props.deleteInvoice(this.props.invoiceIndex);
        this.props._addNotification('A számla törölve lett a kimenetből', 'warning', 30);
    }


    render() {
        return (
            <React.Fragment>
                <tr key={this.state.key} className={this.state.isFirst ? 'border-top-2' : ''}>
                    <td>{this.state.invoice.supplier.name}</td>
                    <td>
                        <a onClick={(event) => this.onShowInvoice()} title="Számlakép">
                            {this.state.invoice.invoiceNumber}
                        </a>
                    </td>
                    <td>{this.state.invoiceItem.lineDescription}</td>
                    <td>
                        <input
                            name='main_bookkeeping_number'
                            value={this.state.invoiceItem.main_bookkeeping_number_custom || this.state.invoiceItem.main_bookkeeping_number}
                            onChange={(event) => this.onSetBookKeepingNumber(event)}
                            className='bordered-input'
                            type='text'
                        />
                    </td>
                    <td>{parseInt(this.state.invoiceItem.vatPercentage * 100, 0)}%</td>
                    <td>{this.state.invoiceItem.vat_collector_title}</td>
                    <td>{this.state.invoiceItem.vat_degree}</td>
                    <td>
                        <i onClick={(event) => this.deleteInvoiceItem()} title='Tétel törlése a kimenetből' className='fa fa-trash-o' aria-hidden='true'></i> &nbsp;
                        <i onClick={(event) => this.deleteInvoice()} title='Számla törlése a kimenetből' className='fa fa-trash' aria-hidden='true'></i>
                    </td>
                </tr>
                {this.state.showInvoice
                    ? <tr>
                        <td colSpan="8">
                            <Invoice
                                {...this.props}
                                invoice={this.state.invoice}
                            />
                        </td>
                    </tr>
                    : null}
            </React.Fragment>
        );
    }
}

export default RowProcessed


// WEBPACK FOOTER //
// ./src/components/supplier/steps/assignment/RowProcessed.js